import { IconProps } from './interfaces';

export const IconEmail = ({ className }: IconProps) => {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 78" className={className}>
            <g>
                <path
                    d="M50.21,0.12c11.56,0,23.12,0.14,34.68-0.04c10.47-0.16,15.2,4.82,15.08,15.25c-0.19,15.76,0.01,31.52,0.01,47.28
    c0,12.71-4.31,15.51-14.88,15.45c-23.58-0.14-47.17-0.08-70.75-0.03c-9.79,0.02-14.4-4.78-14.35-14.52
    c0.08-16.23,0.12-32.45-0.01-48.68C-0.11,4.15,5.31-0.13,15.53,0.07C27.08,0.29,38.65,0.12,50.21,0.12z M94.35,9.72
    C78.04,23.81,63.99,35.95,49.92,48.1C35.07,35.25,21.36,23.4,5.57,9.73c0,19.93,0.46,36.51,0.46,53.05c0,8.04,1.02,9.24,9.62,9.24
    c23.07,0,46.16,0.03,69.24,0.03c9.03,0,9.03-0.93,9.03-8.49C93.92,46.65,94.35,29.71,94.35,9.72z M10.45,6.3
    c14.61,12.73,26.67,23.24,39.54,34.46C62.86,29.47,75.01,18.82,89.28,6.3C62.02,6.3,37.97,6.3,10.45,6.3z"
                ></path>
            </g>
        </svg>
    );
};
